import { render, staticRenderFns } from "./ModalDeleteArticleSource.vue?vue&type=template&id=40002fde"
import script from "./ModalDeleteArticleSource.vue?vue&type=script&lang=js"
export * from "./ModalDeleteArticleSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports